<template>
  <div class="about">
    <div id="wrapper">
      <div class="steps-container">
        <!-- <h2 class="title">Steps Process</h2> -->
        <div class="step" v-for="(step, index) in steps" :key="index" id="step">
          <span class="step-content" :class="(stepCounter > index || stepCounter === 2) && 'active'">
            <i class="fa fa-check" aria-hidden="true"></i>
          </span>
          <h5>{{step.name}}</h5>
        </div>
      </div>
      <div class="content-container" v-if="!state.loading">
        <EmailStep v-if="stepCounter === 0"/>
        <InformationStep :editable="state.editable" v-if="stepCounter === 1"/>
        <ReceiptStep v-if="stepCounter === 2"/>
      </div>
      <div class="loading-container" v-if="state.loading">
        <Loading />
      </div>
      <div class="error-container text-red" v-if="state.error">
        *{{ state.error }}
      </div>
      <div class="buttons mt-5" v-if="stepCounter !== 2">
        <button class="prev mr-4" v-if="stepCounter > 0" @click="onClickPreviousStep"><i class="el-icon-back"></i></button>
        <button class="next" @click="onClickNextStep">
          <span v-if="stepCounter !== 1">Next</span>
          <span v-else>Confirm</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

import EmailStep from '@/components/steps/Email'
import ReceiptStep from '@/components/steps/Receipt'
import InformationStep from '@/components/steps/Information'
import Loading from '@/components/Loading'

export default {
  props: ['admin'],
  components: {
    EmailStep,
    InformationStep,
    ReceiptStep,
    Loading
  },
  data() {
    return {
      stepCounter: 0,
      steps: [
        {
          name: 'Email',
        },
        {
          name: 'Information'
        },
        {
          name: 'Reciept'
        }
      ],
      state: {
        loading: false,
        error: '',
        editable: true,
      }
    }
  },
  created() {
    console.log('Init receipt flow', this.admin)
    if(this.admin) {
      this.stepCounter = 1
    }
  },
  computed: {
    ...mapGetters([
      'email',
      'name',
      'address',
      'tel',
      'company',
    ])
  },
  methods: {
    async onClickNextStep() {
      this.state.loading = true
      this.state.error = ''
      switch (this.stepCounter) {
        case 0:
          await this.checkPayment()
          break;
        case 1:
          if (!this.state.editable) {
            this.stepCounter += 1
          } else {
            await this.openConfirmation()
          }
          break;
        default:
          this.stepCounter += 1;
          break;
      }
      this.state.loading = false
    },
    onClickPreviousStep() {
      this.stepCounter -= 1;
    },
    async checkPayment() {
      try {
        const response = await axios.post('/checkpayment', { email: this.email }) 
        const payment = response.data
        this.$store.dispatch('updatePayment', payment)
        this.$store.dispatch('updateName', `${payment['First name']} ${payment['Last name (family name)']}`)
        this.$store.dispatch('updateTel', `${payment['Telephone']}`)
        await this.checkReciept()
        this.stepCounter += 1;
      } catch (error) {
        console.log(error)
        this.state.error = 'Please check your email address'
      }
    },
    async openConfirmation() {
      this.$confirm('Please verify that the information you are about to submit is correct, you WILL NOT BE ABLE TO edit this information once you have submitted.', 'Confirmation', {
        confirmButtonText: 'Submit',
        cancelButtonText: 'Go back and edit',
        type: 'warning'
      }).then(async () => {
        await this.createReceipt()
        this.$message({
          type: 'success',
          message: 'Submitted'
        });
        this.stepCounter += 1;
      }).catch(() => {       
      });
    },
    async createReceipt() {
      const date = await new Date()
      try {
        const reponse = await axios.post('/createreceipt', {
          email: this.email,
          name: this.name,
          address: this.address,
          tel: this.tel,
          company: this.company,
          date: date
        })
      this.$store.dispatch('updateReceipt', reponse.data)
      } catch (error) {
        this.state.error = 'Invalid fields'
      }
    },
    async checkReciept() {
      try {
        const response = await axios.post('/checkreceipt', { email: this.email })
        if (Object.keys(response.data).length > 0) {
          this.state.editable = false
          this.$store.dispatch('updateName', response.data.name)
          this.$store.dispatch('updateCompany', response.data.company)
          this.$store.dispatch('updateAddress', response.data.address)
          this.$store.dispatch('updateTel', response.data.tel)
          this.$store.dispatch('updateReceipt', response.data)
        }
      } catch (error) {
        this.state.error = ''
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Montserrat');
#wrapper {
  min-height: 800px;
  max-width: 1200px;
  background: #fff;
  border-radius: 5px;
  margin: auto;
  margin-top: 2rem;
  padding: 60px 30px;
  box-shadow : 0px 5px 15px #C9D6FF;
}
.steps-container {
  width: 600px;
  float: none;
  display: block;
  text-align: center;
  margin: auto;
  overflow: hidden;
}
.title {
  color: #333;
  margin-bottom: 60px;
}
.step {
  width: 200px;
  float: left;
}
.step-content {
  width: 40px;
  height: 40px;
  background: #fff;
  display: inline-block;
  border-radius: 100%;
  border: 3px solid #C9D6FF;
  position: relative;
  i {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    line-height: 0;
    font-size: 18px;
    color: #fff;
    font-weight: bold;
  }
  &:after {
    content: "";
    display: block;
    width: 150px;
    height: 2px;
    position: relative;
    background: #C9D6FF;
    margin-left: 45px;
    margin-top: 50%;
    transform: translateY(-50%);
  }
}
.step:last-child .step-content {
  &:after {
    display: none;
  }
}
.step-content.active {
  background: #9AE7DC;
  border-color: #9AE7DC;
  animation: blob .3s ease-out ;
  &:after {
    background: #9AE7DC;
  }
}
.buttons {
  display: block;
  text-align: center;
}
button {
  padding: 13px 30px;
  background: #a9bdfc;
  border: none;
  border-radius: 3px;
  color: white;
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  border: 3px solid #a9bdfc;
  border-radius: 4px;
  transition: background .3s ease-out;
  &:hover {
    background: #C9D6FF;
    border: 3px solid #C9D6FF;
    cursor: pointer;
  }
}
button[disabled] {
  opacity: .5;
}
  
@keyframes blob {
  0% {transform: scale(.5)}
  50% {transform: scale(1.1)}
  100% {transform: scale(1)}
}

@media (max-width: 900px) {
  #wrapper {
    width: 100%;
    margin: auto;
    margin-top: 0px;
  }

  .step {
    width: 110px;
    float: left;
  }
  .steps-container { 
    width: 100%;
  }

  .step-content {
    width: 30px;
    height: 30px;
    background: #fff;
    display: inline-block;
    border-radius: 100%;
    border: 3px solid #C9D6FF;
    position: relative;
    &:after {
      width: 80px;
      height: 2px;
      margin-left: 25px;
    }
  }
  h5 {
    font-size: 1rem;
    display: none;
  }
}
.content-container, .loading-container {
  min-height: 300px;
  // display: flex;
  // justify-content: center;
}
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.text-red {
  color: red;
}
@media print {
  #step, .buttons {
    visibility: hidden;
  }
}
</style>
